import React, { useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { isDesktop, isIOS, isMobile, isTablet } from "react-device-detect"
import useQueryParams from "query-params-hook"
import { replaceByDict } from "../utilities/replace-by-dict"

const AdjustLink = ({
  topMenu,
  slotPage,
  children,
  className,
  menuUrl
}: {
  topMenu?: boolean
  slotPage?: boolean
  className?: string
  children: any,
  menuUrl?: string
}) => {
  const { pathname } = useLocation()
  const {lp: lpPages, campaignid, adgroupid, keyword, adid, lpurl, gclid} = useQueryParams()
  const isLpPage = lpPages === "true";

  if (isDesktop) return children

  const [link, setLink] = useState("")

  useEffect(() => {
    if (isLpPage) {
      const replaceHashed = { campaignid, adgroupid, keyword, adid, lpurl, gclid };
      setLink(replaceByDict("https://app.adjust.com/xmapw1z_nkxn20i?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}", replaceHashed))
      return;
    }
    if (topMenu && pathname.includes("/blog")) {
      setLink("https://app.adjust.com/fvmdki8_rot80ga_becu4kg")
    } else if (topMenu) {
      setLink(menuUrl ?? "https://app.adjust.com/nm6ujoo_m2klajo_79d58ll")
    } else if (slotPage) {
      // demo popup top button
      setLink("https://app.adjust.com/7nrfmf9_x65rik6_77r62yg")
    } else {
      // Hero Link per pathname
      if (pathname === "/") {
        setLink("https://app.adjust.com/5oggskm_q8wp715_y4agz8r")
      } else if (pathname === "/mobile-slots") {
        setLink("https://app.adjust.com/iqxx6kw_ku2478m_eimtls5")
      } else if (pathname === "/free-coins") {
        setLink("https://app.adjust.com/d68ldqz_67hn5xy_4h60vb0")
      } else if (pathname.includes("/slot-games")) {
        setLink("https://app.adjust.com/lmoau0m_rel0k4y_533n8iw")
      }
    }
  }, [])

  return (
    <a href={link} className={className} onClick={() => isLpPage && (window as any).gtag_report_conversion?.()}>
      {children}
    </a>
  )
}

export default AdjustLink
